<template>
  <div class="ss__mobile__menu__wrapper">
    <transition name="menu__fade">
      <div class="comp__SsInput__wrapper" v-show="!submenuVisible">
        <SsInput
          :class="['ss__mobile__menu__input', 'comp__SsInput', {'comp__SsInput--clear': !!keyword}]"
          placeholder="搜索少数派…"
          v-model="keyword"
          @enter="onSearch"
          @focus="onSearchFocus(true)"
          @blur="onSearchFocus(false)">
          <template v-slot:prepend>
            <i class="ssCommunityIcon__search"/>
          </template>
          <template v-slot:append>
            <SsButton2 class="btn__search__clear" @click="onClearSearch" type="text">
              <i class="ssCommunityIcon__error"/>
            </SsButton2>
          </template>
        </SsInput>
      </div>
    </transition>
    <transition :name="menuFadeName">
      <div
        :class="['ss__mobile__menu']"
        v-show="!submenuVisible && !focusInSearch && !keyword">
        <SsMobileMenuItem
          class="comp__SsMobileMenuItem"
          v-for="item in menu"
          :key="item.name"
          :item="item"
          :noJump="true"
          @click.native="onClick(item)"
        />
      </div>
    </transition>
    <transition name="submenu__fade">
      <div
        class="ss__mobile__menu comp__SsMobileSubmenu__wrapper"
        v-show="submenuVisible && !focusInSearch && !keyword">
        <SsMobileSubmenu
          v-if="submenuActive"
          class="comp__SsMobileSubmenu"
          :submenu="submenuActive"
          @back="onBack"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import SsInput from '../SsInput'
import SsButton2 from '../SsButton2'
import SsMobileSubmenu from './_components/SsMobileSubmenu'
import SsMobileMenuItem from './_components/SsMobileMenuItem'

export default {
  name: 'SsMobileMenu',

  components: {
    SsInput,
    SsButton2,
    SsMobileSubmenu,
    SsMobileMenuItem
  },

  props: {
    menu: {
      type: Array,
      default: () => ([])
    },
    searchUrl: String
  },

  data () {
    return {
      submenuActive: null,
      submenuVisible: false,
      keyword: '',
      focusInSearch: false,
      menuFadeName: 'menu__fade'
    }
  },

  methods: {
    onClick (item) {
      this.menuFadeName = 'menu__fade'
      if (item.children && item.children.length) {
        this.submenuActive = item
        this.$nextTick(() => {
          this.submenuVisible = true
        })
      }
    },
    onBack () {
      this.submenuVisible = false
    },
    onClearSearch () {
      this.keyword = ''
    },
    onSearch (value) {
      this.$emit('close')
      this.$bus.$emit('gtag', 'view_search_results', { 'search_term': this.value })
      this.$openLink(this.searchUrl.replace('[keyword]', value))
    },
    onSearchFocus (v) {
      this.focusInSearch = v
      this.menuFadeName = 'menu__fade--focusInSearch'
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/media.styl'
.ss__mobile__menu__wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position relative
}

.ss__mobile__menu__input.comp__SsInput {
  --outline-ssInput: none;
  --inset-ssInput: 8px 0;
  --radius-ssInput: 0px;
  --color-ssInputPlaceholder: var(--B5-t);
  --color-ssInput-default: var(--B5-t);
  caret-color: var(--red-t);
  border-bottom: 1px solid var(--B3-t);
  margin-top: 16px;
  .ssCommunityIcon__search {
    font-size: 24px;
  }
  .btn__search__clear {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    color: var(--B4-t);
    &::before {
      background: transparent;
    }
  }
  >>> .ss__input__prepend {
    padding-right: 0;
    margin-right: 4px;
    transition: .2s;
    &::after {
      display: none;
    }
  }
  >>> .ss__input__append {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 0s, opacity 0.2s 0s;
  }
  >>> &.ss__input__wrapper--focus {
    .ss__input__prepend {
      color: var(--B8-t);
    }
  }
  &.comp__SsInput--clear {
    >>> .ss__input__append {
      visibility: visible;
      opacity: 1;
      transition: visibility 0s 0.2s, opacity 0.2s 0s;
    }
  }
}

.comp__SsInput__wrapper {
  padding: 0 20px;
  margin-bottom: 12px;
}

.ss__mobile__menu {
  width: 100%;
  max-height: 100%;
  overflow: auto;
  padding: 0 20px 20px;
  box-sizing: border-box;
}

.comp__SsMobileMenuItem {
  margin: var(--gap-SsMobileMenuItem, 4px) 0;
}

.comp__SsMobileSubmenu__wrapper {
  position: absolute;
  top: 0;
}

.menu__fade-enter-active,
.menu__fade-leave-active {
  opacity: 1;
  transform: translateX(0px);
  transition: all 0.6s $a-func-default;
}

.menu__fade-enter,
.menu__fade-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

.menu__fade--focusInSearch-enter-active,
.menu__fade--focusInSearch-leave-active {
  opacity: 1;
  transition: all 0.6s $a-func-default;
}

.menu__fade--focusInSearch-enter,
.menu__fade--focusInSearch-leave-to {
  opacity: 0;
}

.submenu__fade-enter-active,
.submenu__fade-leave-active {
  opacity: 1;
  transform: translateX(0px);
  transition: all 0.6s $a-func-default;
}

.submenu__fade-enter,
.submenu__fade-leave-to {
  opacity: 0;
  transform: translateX(40px);
}
</style>
